import React from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

const NestedHistoryTable = ({ columns, data }) => {
  const table = useMaterialReactTable({
    columns,
    data,
    enablePagination: false,
    enableTopToolbar: false,
    initialState: { showColumnFilters: false },
  });
  return <MaterialReactTable table={table} />;
};

export default NestedHistoryTable;
